<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="epi"> </p>
<p class="epigraph-epi"><span epub:type="pagebreak" id="pg_ix" title="ix">With that Christian brake out with a loud voice: Oh, I see him again! and he tells me, “When thou passest through the waters, I will be with thee, and through the rivers, they shall not overflow thee.”</span></p>
<p class="epigraph-epi">Then they both took courage, and the enemy was after that as still as a stone, until they were gone over. Christian therefore presently found ground to stand upon; and so it followed that the rest of the river was but shallow. Thus they got over.</p>
<p class="epigraph-source-epis">—<span class="ePub-SC">JOHN BUNYAN</span>, <span class="ePub-I">The Pilgrim’s Progress</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?44b06248